/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportRepresentation
 */
export interface ReportRepresentation {
    /**
     * 
     * @type {string}
     * @memberof ReportRepresentation
     */
    reportConfigKey: string;
    /**
     * 
     * @type {string}
     * @memberof ReportRepresentation
     */
    reportId: string;
    /**
     * 
     * @type {number}
     * @memberof ReportRepresentation
     */
    queuedAt: number;
}

/**
 * Check if a given object implements the ReportRepresentation interface.
 */
export function instanceOfReportRepresentation(value: object): value is ReportRepresentation {
    if (!('reportConfigKey' in value) || value['reportConfigKey'] === undefined) return false;
    if (!('reportId' in value) || value['reportId'] === undefined) return false;
    if (!('queuedAt' in value) || value['queuedAt'] === undefined) return false;
    return true;
}

export function ReportRepresentationFromJSON(json: any): ReportRepresentation {
    return ReportRepresentationFromJSONTyped(json, false);
}

export function ReportRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'reportConfigKey': json['reportConfigKey'],
        'reportId': json['reportId'],
        'queuedAt': json['queuedAt'],
    };
}

export function ReportRepresentationToJSON(json: any): ReportRepresentation {
    return ReportRepresentationToJSONTyped(json, false);
}

export function ReportRepresentationToJSONTyped(value?: ReportRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reportConfigKey': value['reportConfigKey'],
        'reportId': value['reportId'],
        'queuedAt': value['queuedAt'],
    };
}

